import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12 relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <p className="relative font-mono text-xs tracking-[0.3em] text-emerald-400 uppercase">Attendance OS</p>
        <div className="relative">
          <h1 className="font-display text-5xl font-extrabold tracking-tight leading-none">Every punch.<br />Live.</h1>
          <p className="text-slate-400 mt-6 max-w-sm">Real-time attendance, weekly offs, late tracking and monthly reports in one control room.</p>
        </div>
        <p className="relative font-mono text-xs text-slate-500">Mohammed Naser Al Hammadi Contracting Company · Saudi Arabia</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 rise">
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900" data-testid="login-back-to-kiosk"><ArrowLeft size={14} /> Kiosk</Link>
          <div>
            <p className="font-mono text-xs font-bold tracking-[0.2em] text-emerald-600 uppercase">Admin</p>
            <h2 className="font-display text-3xl font-extrabold text-slate-900">Sign in</h2>
          </div>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="admin-login-email-input" className="w-full h-12 px-4 rounded-lg border border-slate-300 bg-white focus:border-slate-900 outline-none transition-colors" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-login-password-input" className="w-full h-12 px-4 rounded-lg border border-slate-300 bg-white focus:border-slate-900 outline-none transition-colors" />
          {error && <p data-testid="admin-login-error" className="text-sm text-rose-600">{error}</p>}
          <button disabled={busy} data-testid="admin-login-submit-btn" className="w-full h-12 rounded-full bg-slate-900 hover:bg-emerald-500 hover:text-slate-950 text-white font-semibold disabled:opacity-50 active:scale-[0.98] transition-colors">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
